import SocialMediaSharing from './SocialMediaSharing';
export default SocialMediaSharing;
